// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PortalModalFooter_footer-content__E81EO {
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding: 0rem 1rem 1rem 1rem;
  gap: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/PortalModal/PortalModalFooter.module.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,qBAAA;EACA,yBAAA;EACA,4BAAA;EACA,SAAA;AACF","sourcesContent":[".footer-content {\n  display: flex;\n  align-items: flex-end;\n  justify-content: flex-end;\n  padding: 0rem 1rem 1rem 1rem;\n  gap: 1rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer-content": `PortalModalFooter_footer-content__E81EO`
};
export default ___CSS_LOADER_EXPORT___;
